import {getOptionalEnvVariable, getRequiredEnvVariable} from './utils/env.utils';

export const env = {
  isProduction: getOptionalEnvVariable('NODE_ENV') === 'production',
  notificationUrl: getRequiredEnvVariable('REACT_APP_THREEDS_EXAMPLE_NOTIFICATION_URL'),
  threeds: {
    url: getRequiredEnvVariable('REACT_APP_THREEDS_URL'),
  },
  acsAuth: {
    url: getRequiredEnvVariable('REACT_APP_ACS_AUTH_URL'),
  },
};
